<template>
  <WhiteIQOS
    bodyClass="billing-company-details-body"
    :title="$t('billing_company_details.title')"
    :subtitle="$t('billing_company_details.subtitle')"
  >
    <div class="gap-column-sm type-row">
      <div class="qrw-label-md bold w-100">
        {{ $t('billing_company_details.type')}}
      </div>
      <BaseSwitcherBar
        tabWidth="80px"
        size="sm"
        v-model="details.type"
        style="background: var(--qrw-background-base-tertiary); border-radius: 10px"
        :tabs="[{text: $t('billing_company_details.sp'), value: 'sp'}, {text:$t('billing_company_details.llc'), value: 'llc'}]"
      />
    </div>
    <BaseDivider color="border-base-tertiary" />
    <div class="gap-column-sm type-row">
      <div class="qrw-label-md bold w-100">
        {{ $t('billing_company_details.name')}}
      </div>
      <BaseTextInput
        size="md"
        @blur="save"
        v-model="details.name"
      />
    </div>
    <BaseDivider color="border-base-tertiary" />
    <div class="gap-column-sm type-row">
      <div class="qrw-label-md bold w-100">
        {{$t('billing_company_details.vat_id')}}
      </div>
      <BaseTextInput
        size="md"
        @blur="save"
        v-model="details.tax_id"
      />
    </div>
    <BaseDivider color="border-base-tertiary" />
    <div class="gap-column-sm type-row">
      <div class="qrw-label-md bold w-100">
        {{$t('billing_company_details.address')}}
      </div>
      <BaseTextInput
        size="md"
        @blur="save"
        v-model="details.address"
      />
    </div>
    <BaseDivider color="border-base-tertiary" />
    <div class="gap-column-sm type-row">
      <div class="qrw-label-md bold w-100">
        {{$t('billing_company_details.delivery_address')}}
      </div>
      <BaseTextInput
        size="md"
        @blur="save"
        v-model="details.delivery_address"
      />
    </div>
  </WhiteIQOS>
</template>


<script>
export default {
  data() {
    return {
      details: {
        type: 'sp',
        name: null,
        tax_id: null,
        address: null,
        delivery_address: null
      }
    }
  },
  methods: {
    save() {
      this.$store.commit('patchCafeGeneralData', {
        official_company: {
          ...this.details
        }
      })
      this.$store.dispatch('saveCafe')
    }
  },
  mounted() {
    const details = this.$store.state.cafe.official_company

    if (details) {
      this.details = details
    }
  }
}
</script>

<style scoped>
.type-row {
  display: flex;
  align-items: center;
  align-content: center;
}
</style>

<style>
.billing-company-details-body {
  padding: 24px !important;
  flex-direction: column;
  row-gap: 24px;
  display: flex;
}
</style>